<template>
  <div id="app">
    <nav>
      <ul>
        <li><a href="/project">Project Intro</a></li>
        <li><a href="/dashboard">Dashboard</a></li>
        <li><a href="/infrahub">Infrahub</a></li>
      </ul>
    </nav>
  </div>
</template>

<script>


export default {
  name: 'Main',
  }
</script>

<style scoped>
nav {
  background-color: #1867C0;
  overflow: hidden;
  margin-bottom: 12px;
}

nav ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

nav ul li {
  float: left;
}

nav ul li a {
  display: block;
  color: white;
  text-align: center;
  padding: 15px 15px;
  text-decoration: none;
}

nav ul li a:hover {
  background-color: #4e82be;
}
</style>